import {FranchiseCashiers} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getFranchiseCashierMovements(context, pagination) {
        return FranchiseCashiers.getFranchiseCashierMovements(pagination).then((response) => {
            return response.data;
        });
    },
    createFranchiseCashier(context, item) {
        return FranchiseCashiers.create(item).then((response) => {
            return response.data;
        });
    },
};

const module = {
    state,
    mutations,
    actions
};

export default module;
